var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ehub-prefill-notification"},[_c('v-icon',{attrs:{"size":"24"}},[_vm._v(" mdi-clipboard-text-multiple-outline ")]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mb-0 ml-1"},[_vm._v(" This enrolment application has been partially "),_c('strong',[_vm._v("pre-filled")]),_vm._v(" with existing ERN data ")])
}]

export { render, staticRenderFns }